import React, { useState } from 'react';
import {
  ButtonSet,
  ClickableTile,
  Modal,
  ModalBody,
} from 'carbon-components-react';
import { Button } from 'carbon-components-react';
import { ArrowRight16 } from '@carbon/icons-react';
import messages from '../../../locales/messages';
import { FormattedMessage } from 'react-intl';
import { segmentTracking } from '../../../lib/tracker';
import './Landing.scss';
import PublicImage from 'src/common/components/PublicImage';

type LandingProps = {
  handleLaunchModal: () => void;
  setOpenLanding: React.Dispatch<React.SetStateAction<boolean>>;
  setPathSelected: React.Dispatch<React.SetStateAction<string>>;
};

export const Landing = ({
  handleLaunchModal,
  setOpenLanding,
  setPathSelected,
}: LandingProps) => {
  const [openLandingModal, setOpenLandingModal] = useState(true);
  const picture = 'images/landing1.svg';

  return (
    <div className="bx--grid watsonxsa_widget">
      <div className="Landing">
        <div className="bx--row nam">
          <div className="bx--col-lg-10 bx--col-md-5 bx--col-sm-3">
            <div className="bx-row landingDiv1">
              <div>
                <p className="type1">
                  <FormattedMessage {...messages.landingTitle} />
                </p>
              </div>
              <div className="mar-02">
                <p className="type2">
                  <FormattedMessage {...messages.landingSubTitle} />
                </p>
              </div>
              <div className="mar-top-06">
                <p className="type3">
                  <FormattedMessage {...messages.landingText1} />
                </p>
              </div>
              <div className="mar-top-06">
                <p className="type3">
                  <FormattedMessage {...messages.landingText2} />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="bx-row ladingDiv1">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
            <div className="bx--row landingDiv2">
              <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                <div className="bx--row">
                  <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-/">
                    <div className="bx--row">
                      <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-2 clickTile">
                        <ClickableTile
                          id="CLick_01"
                          className="Tile"
                          onClick={() => {
                            handleLaunchModal(),
                              setPathSelected('Non-Tech'),
                              segmentTracking('CTA Clicked', {
                                pageTitle: 'Watsonx Orchestrate SA',
                                object: 'Watsonx Orchestrate SA',
                                resultValue: 'CTA clicked',
                                CTA: 'Non-Tech Path Selection',
                                location: 'Watsonx Orchestrate SA',
                                action: '',
                                field: '',
                              });
                          }}
                          role="button"
                        >
                          <div className="bx--row">
                            <div className="bx--col-lg-10 bx--col-md-6 bx--col-sm-3">
                              <p className="TextTile">
                                <FormattedMessage {...messages.path1Btn} />
                              </p>
                            </div>
                            <div className="bx--col-lg-6 bx--col-md-2 bx--col-sm-1 ArrowTile">
                              <ArrowRight16 className="ImageTile" />
                            </div>
                          </div>
                        </ClickableTile>
                      </div>
                      <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-2 clickTile">
                        <ClickableTile
                          id="CLick_02"
                          className="Tile"
                          onClick={() => {
                            handleLaunchModal(),
                              setPathSelected('Tech'),
                              segmentTracking('CTA Clicked', {
                                pageTitle: 'Watsonx Orchestrate SA',
                                object: 'Watsonx Orchestrate SA',
                                resultValue: 'CTA clicked',
                                CTA: 'Tech Path Selection',
                                location: 'Watsonx Orchestrate SA',
                                action: '',
                                field: '',
                              });
                          }}
                          role="button"
                        >
                          <div className="bx--row">
                            <div className="bx--col-lg-10 bx--col-md-6 bx--col-sm-3">
                              <p className="TextTile">
                                <FormattedMessage {...messages.path2Btn} />
                              </p>
                            </div>
                            <div className="bx--col-lg-6 bx--col-md-2 bx--col-sm-1 ArrowTile">
                              <ArrowRight16 className="ImageTile" />
                            </div>
                          </div>
                        </ClickableTile>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
